import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BlogSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/FaqSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/credit-card-points/PointConvertSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/VirtualPvEvent.js");
